<template>
  <div>
    <app-title>PBX</app-title>
    <pbx-login ref="login" v-if="!sessId" @loggedIn="loggedIn"></pbx-login>
    <v-layout v-if="sessId" row wrap>
      <pbx-extensions ref="extensions"></pbx-extensions>
    </v-layout>
  </div>
</template>

<script>
import pbxLogin from "@/components/nampt/pbxLogin";
import pbxExtensions from "@/components/nampt/pbxExtensions";
export default {
  name: "NamptLogin",
  components: {
    pbxLogin,
    pbxExtensions
  },
  data() {
    return {
      sessId: null
    };
  },
  methods: {
    getDomains() {
      this.$refs.extensions.retrieveDomains();
    },
    loggedIn(val) {
      this.sessId = val;
      if (this.$refs.extensions) this.$refs.extensions.retrieveDomains();
    }
  },
  mounted() {
    this.$refs.login.login();
  }
};
</script>

<style scoped>
</style>